/** Two grid rows' worth, so the real cards land where the placeholders were. */
export const MEMORY_SKELETON_COUNT = 4;
